import { combineReducers } from 'redux';

import UserReducer from './user/reducer';
import CompanyReducer from './Company/reducer';
import config from "./config/reducer";
import configReducer from "./config/reducer";

const rootReducer = combineReducers({
  user: UserReducer,
  company: CompanyReducer,
  config: configReducer,
});

export default rootReducer;
